export const clinicalForm_SubSectionType_Variables = 'variables';
export const clinicalForm_SubSectionType_Values = 'values';
export const clinicalForm_SelectionType_Single = 'single';
export const clinicalForm_SelectionType_Many = 'many';
//# sourceMappingURL=types.js.map